import Policies from './PolicyPage'

export default Policies
